// extracted by mini-css-extract-plugin
export default {"button":"As","primary":"Bs","fullWidth":"Cs","secondary":"Es","nutrition":"Fs","underlined":"Gs","small":"Hs","medium":"Is","info":"Js","white":"Ks","border":"Ls","mango":"Ms","charcoal":"Ns","court":"Os","green":"Ps","spark":"Qs","linkButton":"Rs","disabled":"Ss"};
    if(module.hot) {
      // 1743628922656
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  